// extracted by mini-css-extract-plugin
export default {"widget":"widget_widget__dVC67","lastWidget":"widget_lastWidget__bzi5A","centered":"widget_centered__YXWEf"};